var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWarningTriangle = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FFEEEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4171 38.8974L32.6053 16.4703C31.4568 14.4587 28.5529 14.455 27.4008 16.4703L14.5853 38.8974C13.4441 40.8944 14.8852 43.3814 17.1857 43.3814H42.8094C45.1136 43.3814 46.5546 40.8944 45.4171 38.8974ZM28.4687 24.6445H31.4642V33.6527H28.4687V24.6445ZM30.0012 39.6509C28.9662 39.6509 28.1286 38.8133 28.1286 37.7783C28.1286 36.7432 28.9662 35.9057 30.0012 35.9057C31.0362 35.9057 31.8738 36.7432 31.8738 37.7783C31.8738 38.8133 31.0362 39.6509 30.0012 39.6509Z",
    fill: "#E8472E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarningTriangle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning-triangle.4a1d68a6.svg";
export { ForwardRef as ReactComponent };